import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/shared/lib/supabase'

interface UpdateNotificationPreferencesData {
  email_notifications_enabled: boolean
}

async function updateNotificationPreferences(
  userId: string,
  data: UpdateNotificationPreferencesData
): Promise<void> {
  const { error } = await supabase
    .from('users')
    .update({
      email_notifications_enabled: data.email_notifications_enabled,
      updated_at: new Date().toISOString(),
    })
    .eq('id', userId)

  if (error) {
    throw new Error(error.message)
  }
}

export function useUpdateNotificationPreferences(userId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: UpdateNotificationPreferencesData) =>
      updateNotificationPreferences(userId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentUser'] })
    },
  })
}
